<template>
  <article>
    <div class="image">
      <slot name="image"></slot>
    </div>
    <div class="text">
      <span v-if="title" v-cleaned="title" class="title" />
      <span v-if="description" v-cleaned="description" class="description" />
    </div>
  </article>
</template>
<script setup lang="ts">
interface Props {
  color: string;
  description?: string;
  title?: string;
}
const props = defineProps({
  color: null,
  description: null,
  title: null
});

const csscolor = computed(() => props.color ?? '#dcfaea');
</script>
<style lang="scss" scoped>
article {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr auto;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
  gap: var(--gap_s);
}

.image {
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: auto;
}

.title {
  @include font('n', 600, 'secondary');

  display: block;
  transform: scale(0.9);
  transition: opacity 300ms $ease-in-quad 200ms,
    transform 200ms $ease-out-quad 200ms;
  opacity: 0;
  color: var(--color_text);
  .loaded & {
    transform: scale(1);
    opacity: 1;
  }
}

.description {
  display: block;
  transform: scale(0.9);
  transition: opacity 300ms $ease-in-quad 200ms,
    transform 200ms $ease-out-quad 200ms;
  opacity: 0;
  color: var(--color_text);
  @include font('n', 400, 'secondary');
  strong {
    @include font('n', 800, 'secondary');
  }
  .loaded & {
    transform: scale(1);
    opacity: 1;
  }
}
</style>
